import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { get } from '../../../lib/api';
import { setPostTiles } from '../../../lib/redux/campaignDnd/campaignDndSlice';

export const useFetchCampaignPreview = ({ id }) => {
  const dispatch = useDispatch();

  const {
    data: { campaign },
    isFetching,
  } = useQuery(
    ['campaignData', id],
    () => get(`/api/campaigns/previews/${id}`),
    {
      initialData: {
        campaign: { posts: [] },
      },
      enabled: !!id,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (campaign?.posts) {
      dispatch(setPostTiles(campaign.posts));
    }
  }, [campaign, dispatch]);

  return { campaign, isFetching };
};
